import { Button, styled, Typography } from "@material-ui/core";
import { Link } from "gatsby";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  backgroundImage:
    "url(https://www.datocms-assets.com/15671/1650297427-xpress-mobile.png?auto=compress,format)",
  backgroundColor: "#FFB401",
  backgroundPosition: "center left",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  borderRadius: "3px",
  overflow: "hidden",
  padding: theme.spacing(1.5, 2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(2),
    flexDirection: "row"
  },
  [theme.breakpoints.up("sm")]: {
    backgroundSize: "contain",
    minHeight: "60px",
    whiteSpace: "nowrap",
    backgroundImage:
      "url(https://www.datocms-assets.com/15671/1650297433-xpress-dekstop.png?auto=compress,format)"
  },
  // Desktop background
  [theme.breakpoints.up("md")]: {
    borderRadius: "8px"
  }
}));

export const MainTypography = styled(Typography)(({ theme }) => ({
  fontFamily: "Reckless, Georgia",
  fontSize: "2.3rem",
  lineHeight: "2.8rem",
  color: theme.palette.text.primary,
  [theme.breakpoints.down("md")]: {
    fontSize: "2rem",
    lineHeight: "2.2rem"
  },
  [theme.breakpoints.only("sm")]: {
    fontSize: "2.2rem",
    lineHeight: "2.4rem"
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: "1.8rem",
    lineHeight: "2.2rem"
  },
  "& strong": {
    fontWeight: 500
  }
}));

export const CustomButton = styled(Button)(({ theme }) => ({
  width: "100%",
  whiteSpace: "nowrap",
  [theme.breakpoints.up("sm")]: {
    width: "auto"
  },
  [theme.breakpoints.down("xs")]: {}
}));
